export const TERMS_PATH = '/cgu';
export const LEGAL_NOTICE_PATH = '/legal';
export const DATA_AND_PRIVACY_HASH = 'data-and-privacy';

export function getLocalizedLegalPath({
	path,
	locale,
	defaultLocale,
}: {
	path: string;
	locale?: string;
	defaultLocale?: string;
}): string {
	if (!locale || locale === defaultLocale) return path;

	return `/${locale}${path}`;
}
